import { FC } from 'react';

export const Chat: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 4.99999C16.5317 4.99999 20 8.24175 20 12C20 13.3512 19.5617 14.6185 18.7909 15.6993C18.5976 15.9702 18.5518 16.3195 18.6687 16.6311L19.432 18.6665L16.4511 18.0704C16.2402 18.0282 16.0214 18.0551 15.827 18.1472C14.632 18.7131 13.3256 19.0044 12.0034 18.9999L12 18.9999C7.46828 18.9999 4 15.7582 4 12C4 8.24175 7.46828 4.99999 12 4.99999ZM22 12C22 6.92221 17.4083 3 12 3C6.59171 3 2 6.92221 2 12C2 17.0772 6.59081 20.9992 11.9984 20.9999C13.5054 21.0048 14.9958 20.6961 16.375 20.0947L20.8039 20.9805C21.1599 21.0517 21.5266 20.9243 21.7618 20.6477C21.997 20.3711 22.0638 19.9888 21.9363 19.6488L20.7212 16.4085C21.5317 15.1106 22 13.6065 22 12Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 10C7 9.44772 7.44772 9 8 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H8C7.44772 11 7 10.5523 7 10ZM7 14C7 13.4477 7.44772 13 8 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H8C7.44772 15 7 14.5523 7 14Z"
			fill="currentColor"
		/>
	</svg>
);
